
import { Container, Sprite } from 'pixi.js';
import { app } from './../app';
import { storageManager } from './../common/StorageManager';
import { dataImporter } from './../DataImporter';

export class Collectible extends Container {
    constructor(texture){
        super();
        this.icon = new Sprite(texture);
        this.icon.anchor.set(0, 0.5);
        this.icon.scale.set(1.35);
        this.addChild(this.icon);
        this.collected = false;
    }

    onCollected(){
        if (this.collected) return;
        this.collected = true;

        storageManager.increaseScore(5);

        app.sound.play(dataImporter.currPack.missionSelect.sfxPickUp);

        app.tween(this.icon)
            .to({y: -60, alpha: 0}, 200, createjs.Ease.getElasticIn(1.1, 1.5))
            .call(()=> {this.parent.removeChild(this);});
    }
}
